var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17394_161415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.399999C0 0.179086 0.179086 0 0.4 0H11.6C11.8209 0 12 0.179086 12 0.4V1.75542C12 2.03156 11.7761 2.25542 11.5 2.25542H0.5C0.223858 2.25542 0 2.03156 0 1.75542V0.399999Z",
    fill: "#32324D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.96094 2.99544C0.0984375 2.33761 2.08912e-05 2.12616 0 1.64453H11.9766C12.1289 2.32586 11.1797 2.89755 10.8281 3.20688C9.85155 3.88821 7.70155 5.38714 6.91405 5.93219C6.12655 6.47724 5.39845 6.15929 5.1328 5.93219C4.10156 5.22734 1.82344 3.65327 0.96094 2.99544Z",
    fill: "#32324D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4 8H0.6C0.268629 8 0 8.23575 0 8.52657V9.47343C0 9.76425 0.268629 10 0.6 10H11.4C11.7314 10 12 9.76425 12 9.47343V8.52657C12 8.23575 11.7314 8 11.4 8Z",
    fill: "#32324D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.77734V8.89904V9.26319H12V3.77734C10.6836 4.75234 7.8164 6.83389 7.01955 7.36019C6.22265 7.88644 5.34375 7.57944 5.0039 7.36019L0 3.77734Z",
    fill: "#32324D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17394_161415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.948e0488c6c7056b9605fa6fcda08eef.svg";
export { ForwardRef as ReactComponent };